import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import React, { useState } from "react";
import { useNavigate } from "react-router";

function Signin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const loginHandler = () => {
    const auth = getAuth();
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in
        navigate("/");
        // ...
      })
      .catch((error) => {
        document.getElementById("sign-in-error-msg").innerHTML =
          "Invalid email / password";
        setPassword("");
      });
  };

  return (
    <div className="w-screen h-[80vh] flex justify-center items-center">
      <form
        className="flex justify-center items-center flex-col"
        onSubmit={(e) => {
          e.preventDefault();
          if (!email || !password) {
            document.getElementById("sign-in-error-msg").innerHTML =
              "Invalid email / password";
          } else {
            loginHandler();
          }
        }}
      >
        <p
          className="text-[1.9em] md:text-[2.2em] font-semibold text-gold cursor-pointer"
          onClick={() => navigate("/")}
        >
          Kuwait CU
        </p>
        <p className="text-[1.5em] md:text-[1.9em] font-semibold text-gray-700 my-5">
          Log into your Account
        </p>
        <div className="flex justify-start flex-col">
          <p>Email</p>
          <input
            className="w-[80vw] h-[3em] md:w-[30em] border-[1px] border-black rounded-none outline-none px-4 mb-5"
            value={email}
            type="text"
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="flex justify-start flex-col">
          <p>Password</p>
          <input
            className="w-[80vw] h-[3em] md:w-[30em] border-[1px] border-black rounded-none outline-none px-4"
            value={password}
            type="password"
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <p id="sign-in-error-msg" className="font-medium text-red-500 mb-5"></p>
        <button
          type="submit"
          className="bg-black text-white w-[80vw] h-[3em] md:w-[30em]"
        >
          Login
        </button>
        <div className="my-4">
          <p>Don't have an account?</p>
        </div>
        <div className="flex justify-center">
          <img
            src="appstore.svg"
            alt="app store"
            apple
            store
            className="mr-2 cursor-pointer"
            onClick={() =>
              (window.location.href =
                "https://apps.apple.com/us/app/ksab/id6443599059")
            }
          />
          <img
            src="googleplay.svg"
            alt="google"
            google
            store
            className="cursor-pointer"
            onClick={() =>
              (window.location.href =
                "https://play.google.com/store/apps/details?id=com.AliAlmutawa.KSAB")
            }
          />
        </div>
      </form>
    </div>
  );
}

export default Signin;
